import {Injectable} from "@angular/core";

@Injectable()
export class MobileService {

    offsetWidth = document.body.offsetWidth;
    isMobile(){
        if (this.offsetWidth <= 768){
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/mobile.service.ts